import { useMemo } from 'react'
import { useRouter } from 'next/router'

import styled from 'styled-components'

import { device } from '@/common/constants/device'
import { useTranslations } from 'next-intl'

const LANGUAGE_CODES = {
  es: 'es',
  pt: 'pt',
}

const TELEGRAM_LINK = 'https://t.me/adheart'
const TELEGRAM_LINK_EN = 'https://t.me/adheart_english'

const Wrap = styled.section`
  margin-top: 40px;
  padding: 1.5rem 1.25rem 2.25rem 1.25rem;
  border-radius: 24px;

  background: url('/_next_static/landing/socials/bg-s.webp') center 179px /
      273px 191px no-repeat,
    #f5e341;

  @media ${device.tablet} {
    padding: 2.5rem;
    padding-bottom: 23.75rem;
    border-radius: 40px;

    background: url('/_next_static/landing/socials/bg-t.webp') center 296px /
        377px 264px no-repeat,
      radial-gradient(
        40.65% 40.65% at 50% 76.84%,
        #ffb400 0%,
        rgba(255, 180, 0, 0) 100%
      ),
      #ffed4b;
  }

  @media ${device.laptop} {
    padding-bottom: 5.9375rem;

    background: url('/_next_static/landing/socials/bg-t.webp') 584px 31px /
        377px 264px no-repeat,
      radial-gradient(
        39.7% 136.3% at 89.7% 91.59%,
        #ffb400 2.42%,
        rgba(255, 180, 0, 0) 100%
      ),
      #ffed4b;
    border-radius: 40px;
  }

  @media ${device.laptopL} {
    background: url('/_next_static/landing/socials/bg-t.webp') 927px 31px /
        377px 264px no-repeat,
      #ffed4b;
  }
`

const Title = styled.h2`
  margin-bottom: 1.25rem;
  font-weight: 800;
  font-size: 2em;
  line-height: 1.125;
  letter-spacing: -0.02em;

  @media ${device.tablet} {
    margin-bottom: 2.5rem;
    font-size: 3em;
  }

  @media ${device.laptop} {
    width: 500px;
  }
`

const SocialsList = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 14rem;

  @media ${device.tablet} {
    font-size: 3em;
    justify-content: start;
    gap: 1.5rem;
    margin: 0;
  }
`

const SocialsItem = styled.li`
  cursor: pointer;
`

const SocialLink = styled.a`
  display: block;
`

const SocialImage = styled.img`
  width: 30px;
  height: 30px;
  background-size: cover;
  background-repeat: no-repeat;
  border-style: none;

  @media ${device.tablet} {
    width: 32px;
    height: 32px;
  }
`

const Socials = () => {
  const t = useTranslations('index')
  const router = useRouter()
  const { locale } = router
  const BASE_URL = process.env.BASE_URL

  const instagramLink = useMemo(
    () => (LANGUAGE_CODES[locale] ? `.${LANGUAGE_CODES[locale]}` : '_official'),
    [locale]
  )

  const telegramLink =
    locale === 'ru' || locale === 'uk' ? TELEGRAM_LINK : TELEGRAM_LINK_EN

  return (
    <Wrap id="socials">
      <Title>{t('areYouLookingForUsOnSocial')}</Title>
      <SocialsList>
        <SocialsItem>
          <SocialLink
            href={`https://www.twitter.com/${BASE_URL}/`}
            target="_blank"
          >
            <SocialImage
              src="/_next_static/landing/socials/twitter.svg"
              alt="twitter"
            />
          </SocialLink>
        </SocialsItem>

        <SocialsItem>
          <SocialLink
            href={`https://www.instagram.com/adheart${instagramLink}/`}
            target="_blank"
          >
            <SocialImage
              src="/_next_static/landing/socials/inst.svg"
              alt="instagram"
            />
          </SocialLink>
        </SocialsItem>
        <SocialsItem>
          <SocialLink href={`https://www.tiktok.com/`} target="_blank">
            <SocialImage
              src="/_next_static/landing/socials/tiktok.svg"
              alt="tiktok"
            />
          </SocialLink>
        </SocialsItem>
        <SocialsItem>
          <SocialLink href={`https://www.youtube.com/`} target="_blank">
            <SocialImage
              src="/_next_static/landing/socials/youtube.svg"
              alt="youtube"
            />
          </SocialLink>
        </SocialsItem>
        <SocialsItem>
          <SocialLink href={telegramLink} target="_blank">
            <SocialImage
              src="/_next_static/landing/socials/telegram.svg"
              alt="telegram"
            />
          </SocialLink>
        </SocialsItem>
      </SocialsList>
    </Wrap>
  )
}

export default Socials
